import { apiClient } from "./client";

export type AssistantStatus = {
  enabled: boolean;
  model: string | null;
  max_history: number;
};

export type ChatMessage = {
  role: "user" | "assistant";
  content: string;
};

export type ChatResponse = {
  reply: string;
  model: string;
  input_tokens: number | null;
  output_tokens: number | null;
};

export async function getAssistantStatus(): Promise<AssistantStatus> {
  const { data } = await apiClient.get<AssistantStatus>("/api/v1/me/assistant/status");
  return data;
}

export async function chatWithAssistant(messages: ChatMessage[]): Promise<ChatResponse> {
  const { data } = await apiClient.post<ChatResponse>("/api/v1/me/assistant/chat", {
    messages,
  });
  return data;
}
